// extracted by mini-css-extract-plugin
export var contactConfirmButtons = "contactez-nous-module--contact-confirm-buttons--998bb";
export var contactConfirmContainer = "contactez-nous-module--contact-confirm-container--b9c23";
export var contactConfirmMessage = "contactez-nous-module--contact-confirm-message--8d5a0";
export var contactContainer = "contactez-nous-module--contact-container--19028";
export var contactFormTitle = "contactez-nous-module--contact-form-title--d944e";
export var inputHoney = "contactez-nous-module--input-honey--ca842";
export var textLabel = "contactez-nous-module--text-label--f6be3";